import moment from 'moment';
import { isChainHeadSelector, isStoreProfileSelector } from 'selectors/index';
import { initGrid } from 'utils/grid/grid';
import { fetchBigWinnersHistory, downloadBigWinnersHistoryReport } from 'dashboard/actions/big-winners/big-winners.actions';
import { DRAW_GAME_TYPE, INSTANT_GAME_TYPE } from 'app/config/gametype';
import template from './big-winners-history.html';

const NUMBER_OF_MONTHS = 13;

const mapStateToThis = ({ session, config, bigWinners, ui, dictionary }) => {
  const { locale, salesPeriodTimestamp, retailer } = session;
  const { defaultPageNo, pageSizeKey, defaultPageSizes, sortColumnKey, directionKey } = config;
  const isChainHead = isChainHeadSelector({ session });
  const isStoreProfile = isStoreProfileSelector({ session });
  const { items, isLoading } = bigWinners;
  const { pagination } = ui;
  const terms = dictionary.terms[locale];

  return {
    locale,
    salesPeriodTimestamp,
    retailer,
    defaultPageNo,
    pageSizeKey,
    defaultPageSizes,
    sortColumnKey,
    directionKey,
    isChainHead,
    isStoreProfile,
    items,
    isLoading,
    pagination,
    terms,
  };
};

const mapDispatchToThis = {
  fetchBigWinnersHistory,
  downloadBigWinnersHistoryReport,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', 'gettextCatalog', '$state', 'tableService')
class BigWinnersHistoryController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  async $onInit() {
    this.retailerId = this.$state.params.retailerNo || this.retailer.retailerId;
    this.tableConfig = this.tableService.initConfig({ configName: 'bigWinnersHistory' });
    this.headers = this.tableConfig.getHeaders(this.getHeaders());
    this.gameTypes = this.generateGameTypes();
    this.periods = this.generatePeriods();
    this.isDisabledShare = this.$state.params.isDisabledShare;
    this.defaultParams = {
      [this.sortColumnKey]: 'drawDate',
      [this.directionKey]: false,
      [this.pageSizeKey]: this.defaultPageSizes[2],
    };
    this.gridModel = await initGrid(this.fetchBigWinnersHistory, this.defaultParams);
    this.initializeFilters();
    this.search();
  }

  $onDestroy() {
    this.unsubscribe();
  }

  preserveFilters() {
    this.preservedFilters = { ...this.gridModel.pagingModel.filters };
  }

  generateGameTypes() {
    return [
      {
        id: undefined,
        text: this.gettextCatalog.getString('All'),
      },
      {
        id: INSTANT_GAME_TYPE,
        text: this.terms.INSTANT.singular,
      },
      {
        id: DRAW_GAME_TYPE,
        text: this.terms.DRAW.singular,
      },
    ];
  }

  generatePeriods() {
    const arr = [];
    for (let i = 0; i < NUMBER_OF_MONTHS; i++) {
      const date = moment.unix(this.salesPeriodTimestamp).subtract(i, 'months').endOf('month');
      arr.push({
        id: date.format('YYYY-MM-DD'),
        text: date.format('MMM YYYY'),
      });
    }

    return arr;
  }

  initializeFilters() {
    this.gridModel.pagingModel.filters = {
      gameType: this.gameTypes[0].id,
      monthEndDate: this.periods[0].id,
      retailerId: this.retailerId,
    };
  }

  search() {
    this.maintenance = false;
    this.gridModel
      .applyFilters()
      .then(() => {
        this.preserveFilters();
      })
      .catch((err) => {
        console.error('BIG_WINNERS_HISTORY', err);
        this.maintenance = true;
      });
  }

  clearFilter() {
    this.initializeFilters();
    return this.search();
  }

  getHeaders() {
    let headers = [
      {
        text: this.gettextCatalog.getString('Game Name'),
        field: 'gameName',
        sortable: true,
      },
      {
        text: this.gettextCatalog.getString('Winning Amount'),
        field: 'wonAmount',
        sortable: true,
        textAlignment: 'text-right',
      },
      {
        text: this.gettextCatalog.getString('Validation Date'),
        field: 'drawDate',
        sortable: true,
        itextAlignment: 'text-center',
      },
    ];

    if (this.isChainHead && !this.isStoreProfile) {
      const chainHeadHeaders = [
        {
          text: this.gettextCatalog.getString('Store No.'),
          field: 'storeNum',
          sortable: true,
        },
        {
          text: this.gettextCatalog.getString('Retailer No.'),
          field: 'retailerId',
          sortable: true,
        },
        {
          text: this.gettextCatalog.getString('Retailer Name'),
          field: 'retailerName',
          sortable: true,
        },
      ];

      headers = headers.concat(chainHeadHeaders);
    }

    headers = headers.concat([
      {
        text: '',
      },
    ]);

    return headers;
  }

  downloadReport(format) {
    const params = {
      ...this.gridModel.pagingModel,
      ...this.preservedFilters,
      pageSize: 0, // BE contract - pageSize = 0 triggers exporting entire data set
    };
    return this.downloadBigWinnersHistoryReport(params, format);
  }
}

export default class BigWinnersHistoryComponent {
  constructor() {
    this.template = template;
    this.controller = BigWinnersHistoryController;
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/big-winners/components/big-winners-history-component.js